"use client";

import AppStoreButton from "@/shared/components/AppStoreButton";
import { trackLearnInstallClick } from "@/shared/utils/analytics";

import s from "./styles.module.css";

interface Props {
  placement: "hub" | "article";
  lessonSlug?: string;
}

export default function LearnInstallCta({ placement, lessonSlug }: Props) {
  return (
    <section className={s.container} aria-labelledby={`install-title-${placement}`}>
      <div className={s.copy}>
        <p className={s.eyebrow}>Put your knowledge into practice</p>
        <h2 id={`install-title-${placement}`} className={s.title}>
          Start exploring with Sweat Wallet
        </h2>
        <p className={s.description}>
          Manage $SWEAT, discover Web3, and learn by using a self-custody wallet
          built for mobile.
        </p>
      </div>
      <AppStoreButton
        className={s.storeButtons}
        placement={`learn_${placement}`}
        onStoreClick={(store) =>
          trackLearnInstallClick({
            store,
            placement,
            page_type: placement === "hub" ? "learn_hub" : "learn_article",
            ...(lessonSlug ? { lesson_slug: lessonSlug } : {}),
          })
        }
      />
    </section>
  );
}
